export function getLevel(pathStr) {
  if (!pathStr) return 0;
  return (pathStr.match(/\./g) || []).length;
}
